!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("axios")) : "function" == typeof define && define.amd ? define(["axios"], t) : "object" == typeof exports ? exports.axiosCancel = t(require("axios")) : e.axiosCancel = t(e.axios);
}(this, function (e) {
  return function (e) {
    function t(u) {
      if (n[u]) return n[u].exports;
      var s = n[u] = {
        exports: {},
        id: u,
        loaded: !1
      };
      return e[u].call(s.exports, s, s.exports, t), s.loaded = !0, s.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    "use strict";

    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function s(e, t) {
      var n = {
          debug: !1
        },
        u = (0, c.default)({}, n, t),
        s = new i.default(u);
      e.interceptors.request.use(function (e) {
        var t = e.requestId;
        if (t) {
          var n = o.CancelToken.source();
          e.cancelToken = n.token, s.addRequest(t, n.cancel);
        }
        return e;
      }), e.interceptors.response.use(function (e) {
        var t = e.config.requestId;
        return t && s.removeRequest(t), e;
      }), e.cancel = function (e, t) {
        e && s.cancelRequest(e, t);
      }, e.cancelAll = function (e) {
        s.cancelAllRequests(e);
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var o = n(3),
      r = n(1),
      i = u(r),
      a = n(2),
      c = u(a);
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var u = t[n];
            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(e, u.key, u);
          }
        }
        return function (t, n, u) {
          return n && e(t.prototype, n), u && e(t, u), t;
        };
      }(),
      s = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          n(this, e), this.options = t, this.pendingRequests = {};
        }
        return u(e, [{
          key: "addRequest",
          value: function (e, t) {
            this.log("adding request `" + e + "`"), this.has(e) ? (this.cancelRequest(e, "`cancelRequest(" + e + ")` from `RequestManager.addRequest`.\n      Found duplicate pending request."), this.pendingRequests[e] = t) : this.pendingRequests[e] = t;
          }
        }, {
          key: "removeRequest",
          value: function (e) {
            this.log("removing request `" + e + "`"), delete this.pendingRequests[e];
          }
        }, {
          key: "cancelRequest",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "`cancelRequest(" + e + ")` from `RequestManager.cancelRequest`";
            this.log("cancelling request `" + e + "`"), this.has(e) && "function" == typeof this.pendingRequests[e] && (this.pendingRequests[e](t), this.removeRequest(e), this.log("request `" + e + "` cancelled"));
          }
        }, {
          key: "cancelAllRequests",
          value: function (e) {
            for (var t in this.pendingRequests) {
              var n = e || "`cancelRequest(" + t + ")` from `RequestManager.cancelAllRequests`";
              this.cancelRequest(t, n);
            }
          }
        }, {
          key: "has",
          value: function (e) {
            return !!this.pendingRequests[e];
          }
        }, {
          key: "log",
          value: function (e) {
            this.options.debug === !0 && console.log(e);
          }
        }]), e;
      }();
    t.default = s;
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function () {
      var e = {};
      for (var t in arguments) {
        var n = arguments[t];
        for (var u in n) Object.prototype.hasOwnProperty.call(n, u) && (e[u] = n[u]);
      }
      return e;
    };
  }, function (t, n) {
    t.exports = e;
  }]);
});